import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import {ProjectFilterModel,ModelPredictionsInputsResponse,FilterResponse } from '../../../shared/models/store/filter.model'; 
import { Observable } from 'rxjs';
import { DropdownsDataResponse } from '../../../shared/models/store/filter.model';
import { ProjectsResponse } from '../../models/store/project'; 

@Injectable({
    providedIn: 'root'
  })

  
  export class ModelSelectionBarService {

    constructor(private apiService: ApiService) { }


    getSats(): Observable<FilterResponse> {
        return this.apiService.get('api/Data/GetAllSats/sats');
      }
    
      getRegions(): Observable<FilterResponse> {
        return this.apiService.get('api/Data/GetAllRegions/regions');

      }
    
      getCommodities(): Observable<FilterResponse> {
        return this.apiService.get('api/Data/GetAllCommodities/commodities');

      }
      getAllProjects(): Observable<ProjectsResponse> {
        return this.apiService.get('api/Data/GetAllProjects/getAllProjects');

      }
      GetInputsAndValues(filterRequest: ProjectFilterModel): Observable<ModelPredictionsInputsResponse> {
          return this.apiService.post('api/Data/GetInputsAndValues', filterRequest );
      }

      filterProjects(filterRequest: ProjectFilterModel): Observable<ProjectsResponse> {
          return this.apiService.post('api/Data/GetProjects/filter', filterRequest );

      }

      getDropdownsData(): Observable<DropdownsDataResponse> {
        return this.apiService.get('api/Data/GetDropdownsData/dropdownsData');
      }

  }